import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { CustomerService } from 'src/app/services/customer.service';
import { GeneralService } from 'src/app/services/general.service';
import Swal from 'sweetalert2';
import { URL_DOCS } from 'src/app/config/config';

type PerfilBg = 'paciente' | 'doctor' | 'trabajadores';
type BgAction = 'update' | 'delete';

@Component({
  selector: 'app-admin-customer',
  templateUrl: './admin-customer.component.html',
  styleUrls: ['./admin-customer.component.css']
})
export class AdminCustomerComponent implements OnInit {
  @ViewChild('editCustomerTri') editCustomerTri: ElementRef;
  @ViewChild('deleteCustomerTri') deleteCustomerTri: ElementRef;
  @ViewChild('addCustomerTri') addCustomerTri: ElementRef;
  @ViewChild('showProductsTri') showProductsTri: ElementRef;
  @ViewChild('insProductsTri') insProductsTri: ElementRef;

  customers: any[] = [];
  editSelected: any = {};
  deleteSelected: any = {};
 
  customerSelected: any = {};
  addCustomerForm: FormGroup;
  editCustomerForm: FormGroup;
  editColorsForm: FormGroup;
  editDefaultColorsForm: FormGroup;
  productForm: FormGroup;

  addCustomerSubmitted = false;
  editCustomerSubmitted = false;
  productSubmitted = false;

  newCustomer: any = this.emptyCustomerState();

  editCustomerSelected: any = {
    cus_id: null,
    cus_image: null,
    cus_name: '',
    cus_url_site: '',
    cus_url_phone: '',
    cus_can_pay: false,
    cus_can_snabb: false,
    cus_can_show_agreement: false,
    cus_can_ivirtual: false,
    cus_can_examedi: false,
    cus_can_yapp: false,
    cus_can_convenio_particular: false,
    cus_can_subscription_planilla: false,
    cus_can_subscription_mp: false,
    cus_can_subscription_wp: false,
    cus_can_subscription_vp: false,
    cus_can_subscription_card: false,
    cus_can_validate_autentika: false,
    cus_url_wsp: '',
    link_centro_ayuda: '',
    link_volver_sitio: '',
    cus_mail_contact: '',
    img_background: [],
    img_background_default: [],
    colors_list: [],
    colors_list_default: []
  };

  newProduct: any = {
    cus_ben_id: '',
    pro_value: ''
  };

  editCustomerColors: any = this.emptyColorState(false);
  editCustomerDefaultColors: any = this.emptyColorState(false);

  URL_DOCS = URL_DOCS;

  private bgObjectUrls: Partial<Record<PerfilBg, string>> = {};
  private bgLastFiles: Partial<Record<PerfilBg, File>> = {};
  private bgActionPending: Partial<Record<PerfilBg, BgAction>> = {};
  private bgDefaultActionPending: Partial<Record<PerfilBg, BgAction>> = {};
  private bgRemovePending: Partial<Record<PerfilBg, boolean>> = {};

  // ============================
  // Fondos por perfil
  // ============================
  editCustomerBackgrounds: {
    paciente: { enabled: boolean; file: File | null; url?: string | null };
    doctor: { enabled: boolean; file: File | null; url?: string | null };
    trabajadores: { enabled: boolean; file: File | null; url?: string | null };
  } = {
    paciente: { enabled: false, file: null, url: null },
    doctor: { enabled: false, file: null, url: null },
    trabajadores: { enabled: false, file: null, url: null }
  };

  // ============================
  // Fondos predeterminados
  // ============================
  editCustomerBackgroundsDefault: {
    paciente: { enabled: boolean; file: File | null; url?: string | null };
    doctor: { enabled: boolean; file: File | null; url?: string | null };
    trabajadores: { enabled: boolean; file: File | null; url?: string | null };
  } = {
    paciente: { enabled: false, file: null, url: null },
    doctor: { enabled: false, file: null, url: null },
    trabajadores: { enabled: false, file: null, url: null }
  };

  activeEditTab: 'datos' | 'colores' | 'fondos' = 'datos';

  constructor(
    private customerService: CustomerService,
    private generalService: GeneralService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
    this.addCustomerForm = this.buildCustomerForm();
    this.editCustomerForm = this.buildCustomerForm();
    this.editColorsForm = this.buildColorsForm();
    this.editDefaultColorsForm = this.buildColorsForm();
    this.productForm = this.fb.group({
      pro_value: ['', Validators.required],
      cus_ben_id: ['', Validators.required]
    });

    this.configureSubscriptionCardLogic(this.addCustomerForm);
    this.configureSubscriptionCardLogic(this.editCustomerForm);
  }

  ngOnInit(): void {
    this.postListarCustomer();
    this.resetNewCustomer();
    this.resetCustomerEditState();
    this.resetProductForm();
  }

  // =========================================================
  // FORMULARIOS REACTIVOS
  // =========================================================

  private buildCustomerForm(): FormGroup {
    return this.fb.group({
      cus_image: [null],

      // ÚNICOS DATOS OBLIGATORIOS
      cus_name: ['', Validators.required],
      cus_url: ['', Validators.required],
      cus_phone: ['', Validators.required],
      cus_url_wsp: ['', Validators.required],
      link_centro_ayuda: ['', Validators.required],
      link_volver_sitio: ['', Validators.required],
      cus_mail_contact: ['', [Validators.required, Validators.email]],

      // CONFIGURACIONES OPCIONALES
      cus_can_pay: [false],
      cus_can_snabb: [false],
      cus_can_show_agreement: [false],
      cus_can_ivirtual: [false],
      cus_can_examedi: [false],
      cus_can_yapp: [false],
      cus_can_convenio_particular: [false],
      cus_can_subscription_planilla: [false],
      cus_can_subscription_mp: [false],
      cus_can_subscription_wp: [false],
      cus_can_subscription_vp: [false],
      cus_can_subscription_card: [false],
      cus_can_validate_autentika: [false]
    });
  }

  private buildColorsForm(): FormGroup {
    return this.fb.group({
      enabled: [false],
      cus_color_1: [null],
      cus_color_2: [null],
      cus_color_3: [null],
      cus_color_4: [null],
      cus_color_5: [null],
      cus_color_6: [null]
    });
  }

  private configureSubscriptionCardLogic(form: FormGroup): void {
    form.get('cus_can_subscription_card')?.valueChanges.subscribe((value: boolean) => {
      if (!value) {
        form.patchValue(
          {
            cus_can_subscription_mp: false,
            cus_can_subscription_wp: false,
            cus_can_subscription_vp: false
          },
          { emitEvent: false }
        );
      }
    });
  }

  private emptyCustomerState(): any {
    return {
      cus_image: null,
      cus_name: '',
      cus_url: '',
      cus_phone: '',
      cus_url_wsp: '',
      link_centro_ayuda: '',
      link_volver_sitio: '',
      cus_mail_contact: '',
      cus_can_pay: false,
      cus_can_snabb: false,
      cus_can_show_agreement: false,
      cus_can_ivirtual: false,
      cus_can_examedi: false,
      cus_can_yapp: false,
      cus_can_convenio_particular: false,
      cus_can_subscription_planilla: false,
      cus_can_subscription_mp: false,
      cus_can_subscription_wp: false,
      cus_can_subscription_vp: false,
      cus_can_subscription_card: false,
      cus_can_validate_autentika: false
    };
  }

  private emptyColorState(enabled: boolean): any {
    return {
      enabled,
      cus_color_1: null,
      cus_color_2: null,
      cus_color_3: null,
      cus_color_4: null,
      cus_color_5: null,
      cus_color_6: null
    };
  }

  private mapCustomerToForm(customer: any): any {
    return {
      cus_image: null,
      cus_name: customer?.cus_name || '',
      cus_url: customer?.cus_url_site ?? customer?.cus_url ?? '',
      cus_phone: customer?.cus_url_phone ?? customer?.cus_phone ?? '',
      cus_url_wsp: customer?.cus_url_wsp || '',
      link_centro_ayuda: customer?.link_centro_ayuda || '',
      link_volver_sitio: customer?.link_volver_sitio || '',
      cus_mail_contact: customer?.cus_mail_contact || '',
      cus_can_pay: !!customer?.cus_can_pay,
      cus_can_snabb: !!customer?.cus_can_snabb,
      cus_can_show_agreement: !!customer?.cus_can_show_agreement,
      cus_can_ivirtual: !!customer?.cus_can_ivirtual,
      cus_can_examedi: !!customer?.cus_can_examedi,
      cus_can_yapp: !!customer?.cus_can_yapp,
      cus_can_convenio_particular: !!customer?.cus_can_convenio_particular,
      cus_can_subscription_planilla: !!customer?.cus_can_subscription_planilla,
      cus_can_subscription_mp: !!customer?.cus_can_subscription_mp,
      cus_can_subscription_wp: !!customer?.cus_can_subscription_wp,
      cus_can_subscription_vp: !!customer?.cus_can_subscription_vp,
      cus_can_subscription_card: !!customer?.cus_can_subscription_card,
      cus_can_validate_autentika: !!customer?.cus_can_validate_autentika
    };
  }

  public isFieldInvalid(form: FormGroup, field: string, submitted: boolean): boolean {
    const control = form.get(field);
    if (!control) {
      return false;
    }

    return control.invalid && (control.touched || control.dirty || submitted);
  }

  public getFieldError(form: FormGroup, field: string): string {
    const control: AbstractControl | null = form.get(field);

    if (!control || !control.errors) {
      return '';
    }

    if (control.errors.required) {
      return 'Este campo es obligatorio.';
    }

    if (control.errors.email) {
      return 'Ingrese un correo electrónico válido.';
    }

    return 'El valor ingresado no es válido.';
  }

  // =========================================================
  // LISTADO / ELIMINACIÓN
  // =========================================================

  async postListarCustomer(): Promise<void> {
    this.customers = [];
    this.generalService.modalCargando();

    await this.customerService.postListarCustomer({ products_list: true })
      .then((result: any) => {
        this.customers = result;
        Swal.close();
      })
      .catch(() => {
        Swal.close();
      });
  }

  deleteCustomer(customer: any): void {
    this.deleteSelected = customer;
    this.renderer.selectRootElement(this.deleteCustomerTri.nativeElement).click();
  }

  confirmDelete(): void {
    if (!this.deleteSelected.cus_id) {
      this.generalService.modalError('Falta información', 'Debe seleccionar un cliente.');
      return;
    }

    this.generalService.modalCargando();
    this.renderer.selectRootElement(this.deleteCustomerTri.nativeElement).click();

    this.customerService.postBorrarCustomer(this.deleteSelected.cus_id)
      .then(async () => {
        this.generalService.modalExitoso('Cliente eliminado', 'El cliente se eliminó exitosamente.');
        await this.generalService.sleep(1000);
        this.ngOnInit();
      })
      .catch(() => {
        this.generalService.modalError('Error en eliminar', 'El cliente no se pudo eliminar.');
      });
  }

  // =========================================================
  // CREAR CLIENTE
  // =========================================================

  private resetNewCustomer(): void {
    this.newCustomer = this.emptyCustomerState();
    this.addCustomerSubmitted = false;

    this.addCustomerForm.reset(this.emptyCustomerState(), { emitEvent: false });
  }

  addCustomer(): void {
    this.resetNewCustomer();
    this.renderer.selectRootElement(this.addCustomerTri.nativeElement).click();
  }

  closeCrearCustomer(): void {
    this.resetNewCustomer();
  }

  onFileSelected(event: any): void {
    const file = this.validateCustomerImage(event);
    if (!file) {
      return;
    }

    this.newCustomer.cus_image = file;
    this.addCustomerForm.patchValue({ cus_image: file });
    this.addCustomerForm.get('cus_image')?.updateValueAndValidity();

    event.target.value = '';
  }

  confirmAdd(): void {
    this.addCustomerSubmitted = true;

    if (this.addCustomerForm.invalid) {
      this.addCustomerForm.markAllAsTouched();
      this.generalService.modalError(
        'Formulario incompleto',
        'Debe completar todos los datos obligatorios del cliente.'
      );
      return;
    }

    const value = this.addCustomerForm.getRawValue();
    this.newCustomer = { ...value };

    this.renderer.selectRootElement(this.addCustomerTri.nativeElement).click();
    this.generalService.modalCargando();

    this.customerService.postCrearCustomer(
      value.cus_name,
      value.cus_url,
      value.cus_phone,
      value.cus_image,
      value.cus_can_pay,
      value.cus_can_snabb,
      value.cus_can_show_agreement,
      value.cus_can_ivirtual,
      value.cus_can_examedi,
      value.cus_can_yapp,
      value.cus_can_convenio_particular,
      value.cus_can_subscription_planilla,
      value.cus_can_subscription_mp,
      value.cus_can_subscription_wp,
      value.cus_can_subscription_vp,
      value.cus_can_subscription_card,
      value.cus_can_validate_autentika,
      value.cus_url_wsp,
      value.link_centro_ayuda,
      value.link_volver_sitio,
      value.cus_mail_contact
    )
      .then(async () => {
        this.generalService.modalExitoso('Ingresado', 'Se ha creado el cliente.');
        await this.generalService.sleep(500);
        this.ngOnInit();
      })
      .catch(() => {
        this.generalService.modalError('Error', 'Error al crear cliente.');
      });
  }

  // =========================================================
  // EDITAR CLIENTE
  // =========================================================

  editCustomer(customer: any): void {
    this.resetEditTabs();
    this.resetCustomerEditState();

    this.editSelected = customer;
    this.editCustomerSelected = JSON.parse(JSON.stringify(customer));
    this.editCustomerSubmitted = false;

    this.editCustomerForm.reset(
      this.mapCustomerToForm(this.editCustomerSelected),
      { emitEvent: false }
    );

    this.editCustomerColors = this.emptyColorState(false);
    if (this.editCustomerSelected.colors_list?.length > 0) {
      this.editCustomerColors = {
        ...this.emptyColorState(false),
        ...this.editCustomerSelected.colors_list[0]
      };
    }
    this.editColorsForm.reset(this.editCustomerColors, { emitEvent: false });

    this.editCustomerDefaultColors = this.emptyColorState(false);
    if (this.editCustomerSelected.colors_list_default?.length > 0) {
      this.editCustomerDefaultColors = {
        ...this.emptyColorState(false),
        ...this.editCustomerSelected.colors_list_default[0]
      };
    }
    this.editDefaultColorsForm.reset(this.editCustomerDefaultColors, { emitEvent: false });

    this.applyCustomerBackgroundsFromApi(
      this.editCustomerSelected.img_background,
      this.editCustomerSelected.img_background_default,
      this.URL_DOCS
    );

    this.applyCustomerDefaultBackgroundsFromApi(
      this.editCustomerSelected.img_background_default,
      this.URL_DOCS
    );

    this.renderer.selectRootElement(this.editCustomerTri.nativeElement).click();
    this.forceEditTabDatos();
  }

  onFileSelectedEdit(event: any): void {
    const file = this.validateCustomerImage(event);
    if (!file) {
      return;
    }

    this.editCustomerSelected.cus_image = file;
    this.editCustomerForm.patchValue({ cus_image: file });
    this.editCustomerForm.get('cus_image')?.updateValueAndValidity();

    event.target.value = '';
  }

  private validateCustomerImage(event: any): File | null {
    if (!event?.target?.files?.[0]) {
      this.generalService.modalError('Seleccione otra imagen', 'Imagen no válida');
      return null;
    }

    const file: File = event.target.files[0];
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    const maxBytes = 20 * 1024 * 1024;

    if (!allowedTypes.includes(file.type)) {
      this.generalService.modalError(
        'Formato no permitido',
        'Solo se permiten imágenes JPG o PNG.'
      );
      event.target.value = '';
      return null;
    }

    if (file.size > maxBytes) {
      this.generalService.modalError(
        'Archivo muy grande',
        'La imagen no puede superar los 20 MB.'
      );
      event.target.value = '';
      return null;
    }

    return file;
  }

  confirmEdit(): void {
    this.editCustomerSubmitted = true;

    if (!this.editCustomerSelected.cus_id) {
      this.generalService.modalError('Falta información', 'Debe seleccionar un cliente.');
      return;
    }

    if (this.editCustomerForm.invalid) {
      this.editCustomerForm.markAllAsTouched();
      this.generalService.modalError(
        'Formulario incompleto',
        'Debe completar todos los datos obligatorios del cliente.'
      );
      return;
    }

    const value = this.editCustomerForm.getRawValue();
    const imageFile = value.cus_image instanceof File ? value.cus_image : null;

    // Mantener sincronizado el objeto usado por el resto de la lógica del componente.
    Object.assign(this.editCustomerSelected, {
      cus_name: value.cus_name,
      cus_url_site: value.cus_url,
      cus_url_phone: value.cus_phone,
      cus_url_wsp: value.cus_url_wsp,
      link_centro_ayuda: value.link_centro_ayuda,
      link_volver_sitio: value.link_volver_sitio,
      cus_mail_contact: value.cus_mail_contact,
      cus_can_pay: value.cus_can_pay,
      cus_can_snabb: value.cus_can_snabb,
      cus_can_show_agreement: value.cus_can_show_agreement,
      cus_can_ivirtual: value.cus_can_ivirtual,
      cus_can_examedi: value.cus_can_examedi,
      cus_can_yapp: value.cus_can_yapp,
      cus_can_convenio_particular: value.cus_can_convenio_particular,
      cus_can_subscription_planilla: value.cus_can_subscription_planilla,
      cus_can_subscription_mp: value.cus_can_subscription_mp,
      cus_can_subscription_wp: value.cus_can_subscription_wp,
      cus_can_subscription_vp: value.cus_can_subscription_vp,
      cus_can_subscription_card: value.cus_can_subscription_card,
      cus_can_validate_autentika: value.cus_can_validate_autentika
    });

    this.generalService.modalCargando();
    this.renderer.selectRootElement(this.editCustomerTri.nativeElement).click();

    this.customerService.postModificarCustomer({
      cus_id: this.editCustomerSelected.cus_id,
      cus_name: value.cus_name,
      cus_url: value.cus_url,
      cus_phone: value.cus_phone,
      cus_image: imageFile,
      cus_can_pay: value.cus_can_pay,
      cus_can_snabb: value.cus_can_snabb,
      cus_can_show_agreement: value.cus_can_show_agreement,
      cus_can_ivirtual: value.cus_can_ivirtual,
      cus_url_wsp: value.cus_url_wsp,
      link_centro_ayuda: value.link_centro_ayuda,
      link_volver_sitio: value.link_volver_sitio,
      cus_can_examedi: value.cus_can_examedi,
      cus_can_yapp: value.cus_can_yapp,
      cus_can_convenio_particular: value.cus_can_convenio_particular,
      cus_can_subscription_planilla: value.cus_can_subscription_planilla,
      cus_can_subscription_mp: value.cus_can_subscription_mp,
      cus_can_subscription_wp: value.cus_can_subscription_wp,
      cus_can_subscription_vp: value.cus_can_subscription_vp,
      cus_can_subscription_card: value.cus_can_subscription_card,
      cus_can_validate_autentika: value.cus_can_validate_autentika,
      cus_mail_contact: value.cus_mail_contact
    })
      .then(async () => {
        this.generalService.modalExitoso('Modificado', 'Se ha modificado el cliente.');
        await this.generalService.sleep(500);
        this.ngOnInit();
      })
      .catch(error => {
        console.error('Error postModificarCustomer:', error);
        this.generalService.modalError('Error', 'Error al modificar cliente.');
      });
  }

  // =========================================================
  // COLORES
  // =========================================================

  confirmEditColors(): void {
    const customerId = this.editCustomerSelected?.cus_id;

    if (!customerId) {
      this.generalService.modalError('Falta información', 'Debe seleccionar un cliente.');
      return;
    }

    const colors = this.editColorsForm.getRawValue();
    this.editCustomerColors = { ...colors };

    const params = {
      cus_id: customerId,
      ...colors
    };

    this.generalService.modalCargando();
    this.renderer.selectRootElement(this.editCustomerTri.nativeElement).click();

    this.customerService.updateColorsCustomer(params)
      .then(async () => {
        this.generalService.modalExitoso('Modificado', 'Se han modificado los colores.');
        await this.generalService.sleep(500);
        this.ngOnInit();
      })
      .catch(() => {
        this.generalService.modalError('Error', 'Error al modificar colores.');
      });
  }

  confirmEditDefaultColors(): void {
    const customerId = this.editCustomerSelected?.cus_id;

    if (!customerId) {
      this.generalService.modalError('Falta información', 'Debe seleccionar un cliente.');
      return;
    }

    const colors = this.editDefaultColorsForm.getRawValue();
    this.editCustomerDefaultColors = { ...colors };

    const params = {
      cus_id: null,
      cus_id_customer: customerId,
      ...colors
    };

    this.generalService.modalCargando();
    this.renderer.selectRootElement(this.editCustomerTri.nativeElement).click();

    this.customerService.updateColorsCustomer(params)
      .then(async () => {
        this.generalService.modalExitoso(
          'Modificado',
          'Se han modificado los colores predeterminados.'
        );
        await this.generalService.sleep(500);
        this.ngOnInit();
      })
      .catch(() => {
        this.generalService.modalError(
          'Error',
          'Error al modificar colores predeterminados.'
        );
      });
  }

  // =========================================================
  // PRODUCTOS
  // =========================================================

  showProducts(customer: any): void {
    this.customerSelected = customer;
    this.renderer.selectRootElement(this.showProductsTri.nativeElement).click();
  }

  deleteProduct(product: any): void {
    if (!product.cus_ben_pro_id) {
      this.generalService.modalError('Falta información', 'Debe seleccionar un producto.');
      return;
    }

    this.generalService.modalCargando();
    this.customerService.deleteProduct({ cus_ben_pro_id: product.cus_ben_pro_id })
      .then(async () => {
        await this.postListarCustomer();

        for (const element of this.customers) {
          if (element.cus_id == this.customerSelected.cus_id) {
            this.customerSelected = JSON.parse(JSON.stringify(element));
          }
        }
      })
      .catch(() => {
        this.generalService.modalError('Error', 'Error al eliminar producto.');
      });
  }

  private resetProductForm(): void {
    this.productSubmitted = false;
    this.newProduct = {
      cus_ben_id: '',
      pro_value: ''
    };

    this.productForm.reset({
      cus_ben_id: '',
      pro_value: ''
    });
  }

  showProduct(): void {
    this.renderer.selectRootElement(this.showProductsTri.nativeElement).click();
    this.renderer.selectRootElement(this.insProductsTri.nativeElement).click();
    this.resetProductForm();
  }

  addProduct(): void {
    this.productSubmitted = true;

    if (this.productForm.invalid) {
      this.productForm.markAllAsTouched();
      this.generalService.modalError('Falta información', 'Debe llenar el formulario.');
      return;
    }

    this.newProduct = this.productForm.getRawValue();

    this.generalService.modalCargando();
    this.customerService.insertProduct(this.newProduct)
      .then(async () => {
        await this.postListarCustomer();

        for (const element of this.customers) {
          if (element.cus_id == this.customerSelected.cus_id) {
            this.customerSelected = JSON.parse(JSON.stringify(element));
          }
        }

        this.renderer.selectRootElement(this.insProductsTri.nativeElement).click();
        this.renderer.selectRootElement(this.showProductsTri.nativeElement).click();
      })
      .catch(() => {
        this.generalService.modalError('Error', 'Error al agregar producto.');
      });
  }

  // =========================================================
  // FONDOS POR PERFIL
  // =========================================================

  private resetCustomerBackgrounds(): void {
    this.cleanupAllBgObjectUrls();
    this.bgRemovePending = {};
    this.bgLastFiles = {};
    this.bgActionPending = {};

    this.editCustomerBackgrounds = {
      paciente: { enabled: false, file: null, url: null },
      doctor: { enabled: false, file: null, url: null },
      trabajadores: { enabled: false, file: null, url: null }
    };
  }

  private resetCustomerBackgroundsDefault(): void {
    this.bgDefaultActionPending = {};

    this.editCustomerBackgroundsDefault = {
      paciente: { enabled: true, file: null, url: null },
      doctor: { enabled: true, file: null, url: null },
      trabajadores: { enabled: true, file: null, url: null }
    };
  }

  private applyCustomerBackgroundsFromApi(
    img_background: any[] | null,
    _img_background_default: any[] | null,
    basePath: string = ''
  ): void {
    this.resetCustomerBackgrounds();

    const perfiles: PerfilBg[] = ['paciente', 'doctor', 'trabajadores'];
    const arrCustom = Array.isArray(img_background) ? img_background : [];

    const buildUrl = (path: string | null | undefined): string | null => {
      const p = String(path || '').trim();
      if (!p) {
        return null;
      }
      if (/^https?:\/\//i.test(p)) {
        return p;
      }
      return basePath + p;
    };

    for (const perfil of perfiles) {
      const item = arrCustom.find(
        x => String(x?.profile_type || '').toLowerCase().trim() === perfil
      );

      const customPath = item?.bg_path ? String(item.bg_path).trim() : '';

      this.editCustomerBackgrounds[perfil].enabled = item?.is_enabled === true;
      this.editCustomerBackgrounds[perfil].file = null;
      this.editCustomerBackgrounds[perfil].url = buildUrl(customPath);
    }
  }

  private applyCustomerDefaultBackgroundsFromApi(
    img_background_default: any[] | null,
    basePath: string = ''
  ): void {
    this.resetCustomerBackgroundsDefault();

    const perfiles: PerfilBg[] = ['paciente', 'doctor', 'trabajadores'];
    const arr = Array.isArray(img_background_default) ? img_background_default : [];

    const buildUrl = (path: string | null | undefined): string | null => {
      const p = String(path || '').trim();
      if (!p) {
        return null;
      }
      if (/^https?:\/\//i.test(p)) {
        return p;
      }
      return basePath + p;
    };

    for (const perfil of perfiles) {
      const item = arr.find(
        x => String(x?.profile_type || '').toLowerCase().trim() === perfil
      );

      if (!item) {
        continue;
      }

      this.editCustomerBackgroundsDefault[perfil].enabled = true;
      this.editCustomerBackgroundsDefault[perfil].file = null;
      this.editCustomerBackgroundsDefault[perfil].url = buildUrl(item?.bg_path);
    }
  }

  public getCustomPreviewUrl(perfil: PerfilBg): string | null {
    const u = String(this.editCustomerBackgrounds?.[perfil]?.url || '').trim();
    return u || null;
  }

  public clearBgPreview(perfil: PerfilBg): void {
    this.editCustomerBackgrounds[perfil].file = null;

    const u = String(this.editCustomerBackgrounds[perfil].url || '');
    if (u.startsWith('data:')) {
      this.editCustomerBackgrounds[perfil].url = null;
    }

    this.cdr.detectChanges();
  }

  private cleanupAllBgObjectUrls(): void {
    (['paciente', 'doctor', 'trabajadores'] as PerfilBg[]).forEach(
      p => this.revokeBgObjectUrl(p)
    );
  }

  private revokeBgObjectUrl(perfil: PerfilBg): void {
    const u = this.bgObjectUrls[perfil];
    if (u) {
      URL.revokeObjectURL(u);
      delete this.bgObjectUrls[perfil];
    }
  }

  onToggleBackgroundPerfil(perfil: PerfilBg, event?: Event): void {
    if (event) {
      const input = event.target as HTMLInputElement;
      this.editCustomerBackgrounds[perfil].enabled = input.checked;
    }

    const state = this.editCustomerBackgrounds[perfil];

    if (state.enabled && !state.file && !this.hasCustomBg(perfil)) {
      state.enabled = false;
      this.generalService.modalError(
        'Sin imagen',
        'Primero debes subir una imagen para activar este perfil.'
      );
    }

    this.bgActionPending[perfil] = 'update';
    this.cdr.detectChanges();
  }

  onToggleBackgroundDefaultPerfil(perfil: PerfilBg): void {
    if (!this.editCustomerBackgroundsDefault[perfil].enabled) {
      this.editCustomerBackgroundsDefault[perfil].enabled = true;
    }
  }

  public getBgPreviewUrlDefault(perfil: PerfilBg): string | null {
    return this.editCustomerBackgroundsDefault?.[perfil]?.url || null;
  }

  public clearBgPreviewDefault(perfil: PerfilBg): void {
    this.editCustomerBackgroundsDefault[perfil].file = null;
    this.editCustomerBackgroundsDefault[perfil].url = null;
  }

  onBgSelectedEditDefault(event: any, perfil: PerfilBg): void {
    if (!event?.target?.files?.[0]) {
      this.generalService.modalError('Seleccione otra imagen', 'Imagen no válida');
      return;
    }

    const file: File = event.target.files[0];
    const allowed = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
    const maxBytes = 20 * 1024 * 1024;

    if (!allowed.includes(file.type)) {
      this.generalService.modalError('Formato no permitido', 'Solo PNG / JPG / WEBP');
      event.target.value = '';
      return;
    }

    if (file.size > maxBytes) {
      this.generalService.modalError('Archivo muy grande', 'Máximo 20 MB');
      event.target.value = '';
      return;
    }

    this.editCustomerBackgroundsDefault[perfil].enabled = true;
    this.editCustomerBackgroundsDefault[perfil].file = file;

    const reader = new FileReader();
    reader.onload = () => {
      this.editCustomerBackgroundsDefault[perfil].url = reader.result as string;
      this.editCustomerBackgroundsDefault[perfil].enabled = true;
      this.cdr.detectChanges();
    };
    reader.readAsDataURL(file);

    event.target.value = '';
  }

  async confirmEditBackgroundsDefault(): Promise<void> {
    try {
      const customerId = Number(this.editCustomerSelected?.cus_id || 0);
      if (!customerId) {
        this.generalService.modalError('Falta información', 'Debe seleccionar un cliente.');
        return;
      }

      const perfiles: PerfilBg[] = ['paciente', 'doctor', 'trabajadores'];

      const actions = perfiles
        .map(perfil => ({
          perfil,
          file: this.editCustomerBackgroundsDefault[perfil]?.file as File | null
        }))
        .filter(x => !!x.file);

      if (actions.length === 0) {
        this.generalService.modalError(
          'Sin cambios',
          'No hay fondos predeterminados para guardar.'
        );
        return;
      }

      this.generalService.modalCargando();

      for (const action of actions) {
        await this.customerService.uploadBackgroundProfileImage(
          999,
          true,
          action.perfil,
          action.file!,
          'update'
        );
      }

      Swal.close();
      this.generalService.modalExitoso(
        'Modificado',
        'Se han actualizado los fondos predeterminados.'
      );

      for (const perfil of perfiles) {
        this.editCustomerBackgroundsDefault[perfil].file = null;
      }

      this.bgDefaultActionPending = {};
      await this.refreshEditedCustomer();
      this.cdr.detectChanges();

    } catch (error) {
      Swal.close();
      this.generalService.modalError(
        'Error',
        'Error al modificar fondos predeterminados.'
      );
      console.error(error);
    }
  }

  onBgSelectedEdit(event: any, perfil: PerfilBg): void {
    if (!event?.target?.files?.[0]) {
      this.generalService.modalError('Seleccione otra imagen', 'Imagen no válida');
      return;
    }

    const file: File = event.target.files[0];
    const allowed = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
    const maxBytes = 20 * 1024 * 1024;

    if (!allowed.includes(file.type)) {
      this.generalService.modalError('Formato no permitido', 'Solo PNG / JPG / WEBP');
      event.target.value = '';
      return;
    }

    if (file.size > maxBytes) {
      this.generalService.modalError('Archivo muy grande', 'Máximo 20 MB');
      event.target.value = '';
      return;
    }

    this.editCustomerBackgrounds[perfil].file = file;
    this.bgLastFiles[perfil] = file;

    const reader = new FileReader();
    reader.onload = () => {
      this.editCustomerBackgrounds[perfil].url = reader.result as string;
      this.cdr.detectChanges();
    };
    reader.readAsDataURL(file);

    event.target.value = '';
  }

  async confirmEditBackgrounds(): Promise<void> {
    try {
      const cusId = Number(this.editCustomerSelected?.cus_id || 0);
      if (!cusId) {
        this.generalService.modalError('Falta información', 'Debe seleccionar un cliente.');
        return;
      }

      const perfiles: PerfilBg[] = ['paciente', 'doctor', 'trabajadores'];
      const actions: Array<{
        perfil: PerfilBg;
        enabled: boolean;
        file: File | null;
        action: BgAction;
      }> = [];

      for (const perfil of perfiles) {
        const desiredEnabled = !!this.editCustomerBackgrounds[perfil]?.enabled;

        const apiArr = Array.isArray(this.editCustomerSelected?.img_background)
          ? this.editCustomerSelected.img_background
          : [];

        const apiItem = apiArr.find(
          (x: any) => String(x?.profile_type || '').toLowerCase().trim() === perfil
        );

        const apiEnabled = apiItem?.is_enabled === true;

        if (this.bgRemovePending?.[perfil] === true) {
          actions.push({
            perfil,
            enabled: false,
            file: null,
            action: 'delete'
          });
          continue;
        }

        if (this.editCustomerBackgrounds[perfil]?.file) {
          actions.push({
            perfil,
            enabled: desiredEnabled,
            file: this.editCustomerBackgrounds[perfil].file,
            action: 'update'
          });
          continue;
        }

        if (desiredEnabled !== apiEnabled) {
          if (!this.hasApiBg(perfil) && desiredEnabled) {
            this.generalService.modalError(
              'Sin imagen',
              `No puedes activar "${perfil}" porque no hay imagen cargada.`
            );
            return;
          }

          actions.push({
            perfil,
            enabled: desiredEnabled,
            file: null,
            action: 'update'
          });
        }
      }

      if (!actions.length) {
        this.generalService.modalError('Sin cambios', 'No hay cambios para guardar.');
        return;
      }

      this.generalService.modalCargando();

      for (const action of actions) {
        await this.customerService.uploadBackgroundProfileImage(
          cusId,
          action.enabled,
          action.perfil,
          action.file,
          action.action
        );
      }

      Swal.close();
      this.generalService.modalExitoso('Modificado', 'Fondos actualizados.');

      this.bgRemovePending = {};
      this.bgActionPending = {};
      await this.refreshEditedCustomer();
      this.cdr.detectChanges();

    } catch (error) {
      Swal.close();
      this.generalService.modalError('Error', 'Error al modificar fondos.');
      console.error(error);
    }
  }

  public hasDefaultBg(perfil: PerfilBg): boolean {
    const u = (this.editCustomerBackgroundsDefault?.[perfil]?.url || '').trim();
    return !!u;
  }

  public removeCustomBg(perfil: PerfilBg): void {
    if (!this.hasDefaultBg(perfil)) {
      this.generalService.modalError(
        'No se puede borrar',
        'No existe un fondo predeterminado para este perfil. Primero sube un default.'
      );
      return;
    }

    this.editCustomerBackgrounds[perfil].enabled = false;
    this.editCustomerBackgrounds[perfil].file = null;
    this.cdr.detectChanges();
  }

  private hasPath(value: any): boolean {
    return !!String(value ?? '').trim();
  }

  public hasCustomBg(perfil: PerfilBg): boolean {
    if (this.bgRemovePending[perfil]) {
      return false;
    }

    const arr = Array.isArray(this.editCustomerSelected?.img_background)
      ? this.editCustomerSelected.img_background
      : [];

    const item = arr.find(
      x => String(x?.profile_type || '').toLowerCase().trim() === perfil
    );

    return this.hasPath(item?.bg_path);
  }

  public canShowCustomActivate(perfil: PerfilBg): boolean {
    return this.hasCustomBg(perfil);
  }

  public canEnableCustom(perfil: PerfilBg): boolean {
    const hasFile = !!this.editCustomerBackgrounds?.[perfil]?.file;
    const hasApiPath = this.hasCustomBg(perfil);
    return hasFile || hasApiPath;
  }

  private async refreshEditedCustomer(): Promise<void> {
    const result: any = await this.customerService.postListarCustomer({ products_list: true });

    const fresh = result.find(
      x => Number(x?.cus_id) === Number(this.editCustomerSelected?.cus_id)
    );

    if (!fresh) {
      return;
    }

    this.editCustomerSelected = JSON.parse(JSON.stringify(fresh));

    this.editCustomerForm.reset(
      this.mapCustomerToForm(this.editCustomerSelected),
      { emitEvent: false }
    );

    if (this.editCustomerSelected.colors_list?.length > 0) {
      this.editCustomerColors = {
        ...this.emptyColorState(false),
        ...this.editCustomerSelected.colors_list[0]
      };
      this.editColorsForm.reset(this.editCustomerColors, { emitEvent: false });
    }

    if (this.editCustomerSelected.colors_list_default?.length > 0) {
      this.editCustomerDefaultColors = {
        ...this.emptyColorState(false),
        ...this.editCustomerSelected.colors_list_default[0]
      };
      this.editDefaultColorsForm.reset(
        this.editCustomerDefaultColors,
        { emitEvent: false }
      );
    }

    this.applyCustomerBackgroundsFromApi(
      this.editCustomerSelected.img_background,
      this.editCustomerSelected.img_background_default,
      this.URL_DOCS
    );

    this.applyCustomerDefaultBackgroundsFromApi(
      this.editCustomerSelected.img_background_default,
      this.URL_DOCS
    );

    this.cdr.detectChanges();
  }

  public canShowRemoveImage(perfil: PerfilBg): boolean {
    const hasFile = !!this.editCustomerBackgrounds?.[perfil]?.file;
    const hasCustom = this.hasCustomBg(perfil);
    return hasFile || hasCustom;
  }

  public removeImage(perfil: PerfilBg): void {
    const hasFile = !!this.editCustomerBackgrounds?.[perfil]?.file;

    if (hasFile) {
      this.editCustomerBackgrounds[perfil].file = null;

      const u = String(this.editCustomerBackgrounds[perfil].url || '');
      if (u.startsWith('data:')) {
        this.editCustomerBackgrounds[perfil].url = null;
      }

      this.bgActionPending[perfil] = 'update';
      this.cdr.detectChanges();
      return;
    }

    if (this.hasCustomBg(perfil)) {
      this.bgRemovePending[perfil] = true;
      this.editCustomerBackgrounds[perfil].enabled = false;
      this.editCustomerBackgrounds[perfil].file = null;

      const defaultUrl = this.getBgPreviewUrlDefault(perfil);
      this.editCustomerBackgrounds[perfil].url = defaultUrl || null;

      this.bgActionPending[perfil] = 'delete';
      this.cdr.detectChanges();
    }
  }

  private existedCustomInApi(perfil: PerfilBg): boolean {
    const arr = Array.isArray(this.editCustomerSelected?.img_background)
      ? this.editCustomerSelected.img_background
      : [];

    const item = arr.find(
      x => String(x?.profile_type || '').toLowerCase().trim() === perfil
    );

    const path = String(item?.bg_path ?? '').trim();
    return !!path;
  }

  public clearBgSelectionDefault(perfil: PerfilBg): void {
    this.editCustomerBackgroundsDefault[perfil].file = null;

    this.applyCustomerDefaultBackgroundsFromApi(
      this.editCustomerSelected?.img_background_default,
      this.URL_DOCS
    );

    this.cdr.detectChanges();
  }

  private buildDocsUrl(path: string): string {
    if (/^https?:\/\//i.test(path)) {
      return path;
    }
    return this.URL_DOCS + path;
  }

  private async getFileForResend(perfil: PerfilBg): Promise<File | null> {
    const selected = this.editCustomerBackgrounds?.[perfil]?.file || null;
    if (selected) {
      return selected;
    }

    const cached = this.bgLastFiles?.[perfil] || null;
    if (cached) {
      return cached;
    }

    const bgPath = this.getApiBgPath(perfil);
    if (!bgPath) {
      return null;
    }

    const url = this.buildDocsUrl(bgPath);

    try {
      const resp = await fetch(url);
      if (!resp.ok) {
        return null;
      }

      const blob = await resp.blob();
      const ext =
        blob.type === 'image/png' ? 'png' :
        blob.type === 'image/webp' ? 'webp' :
        'jpg';

      const file = new File(
        [blob],
        `bg_${perfil}.${ext}`,
        { type: blob.type || 'image/jpeg' }
      );

      this.bgLastFiles[perfil] = file;
      return file;

    } catch (error) {
      console.error('getFileForResend error', perfil, error);
      return null;
    }
  }

  private getApiBgPath(perfil: PerfilBg): string {
    const arr = Array.isArray(this.editCustomerSelected?.img_background)
      ? this.editCustomerSelected.img_background
      : [];

    const item = arr.find(
      (x: any) => String(x?.profile_type || '').toLowerCase().trim() === perfil
    );

    return String(item?.bg_path || '').trim();
  }

  private hasApiBg(perfil: PerfilBg): boolean {
    return !!this.getApiBgPath(perfil);
  }

  private getExistingBgPath(perfil: PerfilBg): string {
    const arr = Array.isArray(this.editCustomerSelected?.img_background)
      ? this.editCustomerSelected.img_background
      : [];

    const item = arr.find(
      (x: any) => String(x?.profile_type || '').toLowerCase().trim() === perfil
    );

    const apiPath = String(item?.bg_path || '').trim();
    if (apiPath) {
      return apiPath;
    }

    const u = String(this.editCustomerBackgrounds?.[perfil]?.url || '').trim();
    if (!u || u.startsWith('data:')) {
      return '';
    }

    const base = String(this.URL_DOCS || '').trim();
    if (base && u.startsWith(base)) {
      return u.slice(base.length);
    }

    return u;
  }

  private hasExistingBg(perfil: PerfilBg): boolean {
    return !!this.getExistingBgPath(perfil);
  }

  // =========================================================
  // RESET / CIERRE MODAL EDITAR
  // =========================================================

  private resetEditTabs(): void {
    this.activeEditTab = 'datos';
  }

  private resetCustomerEditState(): void {
    this.editCustomerSubmitted = false;

    this.editCustomerSelected = {
      cus_id: null,
      cus_image: null,
      cus_name: '',
      cus_url_site: '',
      cus_url_phone: '',
      cus_can_pay: false,
      cus_can_snabb: false,
      cus_can_show_agreement: false,
      cus_can_ivirtual: false,
      cus_url_wsp: '',
      link_centro_ayuda: '',
      link_volver_sitio: '',
      img_background: [],
      img_background_default: [],
      colors_list: [],
      colors_list_default: [],
      cus_can_examedi: false,
      cus_can_yapp: false,
      cus_can_convenio_particular: false,
      cus_can_subscription_planilla: false,
      cus_can_subscription_mp: false,
      cus_can_subscription_wp: false,
      cus_can_subscription_vp: false,
      cus_can_subscription_card: false,
      cus_can_validate_autentika: false,
      cus_mail_contact: ''
    };

    this.editCustomerForm.reset(this.emptyCustomerState(), { emitEvent: false });

    this.editCustomerColors = this.emptyColorState(false);
    this.editCustomerDefaultColors = this.emptyColorState(false);
    this.editColorsForm.reset(this.editCustomerColors, { emitEvent: false });
    this.editDefaultColorsForm.reset(this.editCustomerDefaultColors, { emitEvent: false });

    this.resetCustomerBackgrounds();
    this.resetCustomerBackgroundsDefault();

    this.bgRemovePending = {};
    this.bgLastFiles = {};
    this.bgActionPending = {};
    this.bgDefaultActionPending = {};

    this.cdr.detectChanges();
  }

  onCloseEditCustomerModal(): void {
    this.resetEditTabs();
    this.resetCustomerEditState();
  }

  private forceEditTabDatos(): void {
    setTimeout(() => {
      const el = document.querySelector('#tab-datos-tab') as HTMLElement;
      if (el) {
        el.click();
      }
    }, 0);
  }

  // Se conserva por compatibilidad con llamadas externas antiguas.
  onChangeSubscriptionCard(value: boolean): void {
    if (!value) {
      this.editCustomerForm.patchValue(
        {
          cus_can_subscription_mp: false,
          cus_can_subscription_wp: false,
          cus_can_subscription_vp: false
        },
        { emitEvent: false }
      );

      this.editCustomerSelected.cus_can_subscription_mp = false;
      this.editCustomerSelected.cus_can_subscription_wp = false;
      this.editCustomerSelected.cus_can_subscription_vp = false;
    }
  }
}
